<p-panel header="{{ 'contract_details' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
    <app-loader *ngIf="!isDataReady"></app-loader>    
    <div class="ui-g" *ngIf="isDataReady">
        <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
            <form [formGroup]="contractDetailsForm" (ngSubmit)="onSubmit()">

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_name-input" name="company_name" type="text" pInputText style="width: 100%;" formControlName="company_name"> 
                    <label for="company_name-input">{{ 'company_name' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_street-input" name="company_street" type="text" pInputText style="width: 100%;" formControlName="company_street"> 
                    <label for="company_street-input">{{ 'street' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_house_no-input" name="company_house_no" type="text" pInputText style="width: 100%;" formControlName="company_house_no"> 
                    <label for="company_house_no-input">{{ 'house_no' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_postal_code-input" name="company_postal_code" type="text" pInputText style="width: 100%;" formControlName="company_postal_code"> 
                    <label for="company_postal_code-input">{{ 'postal_code' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_city-input" name="company_city" type="text" pInputText style="width: 100%;" formControlName="company_city"> 
                    <label for="company_city-input">{{ 'city_header' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_nip-input" name="company_nip" type="text" pInputText style="width: 100%;" formControlName="company_nip"> 
                    <label for="company_nip-input">{{ 'tax_number' | translate }}</label>
                </span>         

                <div *ngIf="isEditing == false"> 
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button (click)="startEditing()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                    </div>          
                </div>  
    
                <div class="ui-g" *ngIf="isEditing == true">  
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button pButton type="submit" [disabled]="!contractDetailsForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                    </div>  
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button (click)="cancelEditing()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                    </div>                 
                </div>
            </form>
        </div>
    </div>
</p-panel>

<p-panel header="{{ 'contract_email' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
    <div class="ui-g" *ngIf="isDataReady">
        <div class="ui-g-12">
            <p class="download-link" (click)="onEditContractEmail()">{{ 'contract_email_desc' | translate }}</p>
        </div>
        <div class="ui-g-12" class="test-email">
            <h3>{{ 'contract_email_test' | translate }}</h3>
            <input input type="emial" pInputText [(ngModel)]="testEmailAddress">
            <button (click)="onSendTestEmail()" pButton type="button" label="{{ 'send' | translate }}" class="ui-button-info"></button>
        </div>
    </div>
</p-panel>